import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { updateAppVersion, getAppVersions } from "../../actions";

export const useAppVersionsHook = () => {
   const [paginationData, setPaginationData] = useState({
      limit: 10,
      skip: 0,
      page: 0,
      total: 0
   })

   const [isLoading, setIsLoading] = useState(true);
   const [appVersions, setAppVersions] = useState([])
   const [tableKey, setTableKey] = useState(0)
   const [showAddAppVersionModal, setShowAddAppVersionModal] = useState(false)
   const [showDeleteAppVersionModal, setShowDeleteAppVersionModal] = useState(false)
   const [selectedAppVersionData, setSelectedAppVersionData] = useState({})
   const [appVersionStatusUpdateData, setAppVersionStatusUpdateData] = useState({
      appVersionIndex: -1,
      isLoading: false
   })

   useEffect(() => {
      const updatedPaginationData = {
         limit: paginationData.limit || 10,
         skip: 0,
         page: 0,
         total: 0
      }

      fetchAppVersionsList({ ...updatedPaginationData })
   }, [])

   const fetchAppVersionsList = async (updatedPaginationData = { ...paginationData }, filterData = {}) => {
      try {
         setIsLoading(true)
         setAppVersions([])

         const appVersionsQueryParams = {
            limit: updatedPaginationData.limit || 10,
            skip: updatedPaginationData.skip || 0,
         }

         const appVersionsDataRes = await getAppVersions(appVersionsQueryParams)
         let responseData = (appVersionsDataRes.data && appVersionsDataRes.data.ResponseData) || []
         let appVersionsData = ((responseData && responseData.data) || [])

         setPaginationData({
            ...updatedPaginationData,
            total: responseData.totalCount || 0,
         })

         setAppVersions([...appVersionsData])
         setTableKey(tableKey + 1)
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false)
      }
   }

   const onPageChange = (activePage, selectedSize) => {
      const updatedPaginationData = {
         ...paginationData,
         page: activePage,
         limit: selectedSize,
         skip: selectedSize * activePage
      }
      fetchAppVersionsList({ ...updatedPaginationData })
   }

   const onFilterChange = (filterData = []) => {
      const name = (filterData && filterData[0] && filterData[0].column && filterData[0].column.field) || ""
      const value = (filterData && filterData[0] && filterData[0].value) || ""
      const searchData = {
         [name]: value
      }
      fetchAppVersionsList(paginationData, searchData)
   }

   const handleAppVersionStatusChange = async (isChecked, appVersionIndex, versionData = {}) => {
      try {
         setAppVersionStatusUpdateData({
            appVersionId: versionData.version_id,
            appVersionIndex: appVersionIndex,
            isLoading: true
         })
         const statusPayload = {
            os: versionData.os || "IOS",
            versionCode: versionData.versionCode || "",
            versionName: versionData.versionName || "",
            description: versionData.description || "",
            required: isChecked || false
         }

         const appVersionStatusRes = await updateAppVersion(versionData.version_id, statusPayload)
         toast.success("App version status updated.")

         const appVersionsClone = [...appVersions]
         appVersionsClone[appVersionIndex].required = isChecked
         setAppVersions([...appVersionsClone])
      } catch (error) {
         console.log(error);
         toast.error("spmething went wrong while updating app version status.")
      } finally {
         setAppVersionStatusUpdateData({
            appVersionIndex: -1,
            isLoading: false
         })
      }
   }

   const toggleAddAppVersionModal = (isOpen, appVersionData = {}, refreshData = false) => {
      setSelectedAppVersionData({ ...appVersionData })
      setShowAddAppVersionModal(isOpen)

      if (refreshData) {
         fetchAppVersionsList()
      }
   }

   const toggleDeleteAppVersionModal = (isOpen, appVersionData = {}, refreshData = false) => {
      setSelectedAppVersionData({ ...appVersionData })
      setShowDeleteAppVersionModal(isOpen)

      if (refreshData) {
         fetchAppVersionsList()
      }
   }

   return {
      tableKey,
      paginationData,
      isLoading,
      appVersions,
      appVersionStatusUpdateData,
      selectedAppVersionData,
      showAddAppVersionModal,
      showDeleteAppVersionModal,
      handleAppVersionStatusChange,
      onPageChange,
      onFilterChange,
      toggleAddAppVersionModal,
      toggleDeleteAppVersionModal
   }
}